var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-area",style:({'width': _vm.width + 'px', 'height': _vm.height + 'px'})},[_c('div',{staticClass:"loading-area__loading"})])
}
var staticRenderFns = []

export { render, staticRenderFns }